
export const Methods = {
  HEAD: 'HEAD',
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

// Headers
const DefaultHeaders = {};

function throwOnNotOk( response) {
  if( !response.ok) throw response;
  return response;
}

async function tryParseOnNetworkError( error) {
  try {
    if( error.text) error.message = await error.text();
  } catch( metaError) {
    console.error( new Date(), 'helpers::Network::Call::tryParseOnNetworkError - metaError: ', metaError);
  };
  throw error;
}

export default async function Call( url, fetchOptions = {}, { parseResponse = false } = {}) {
  try {
    if( !fetchOptions) fetchOptions = {};
    if( !fetchOptions.headers) fetchOptions.headers = {};
    fetchOptions.headers = { ...DefaultHeaders, ...fetchOptions.headers };
    const response = await fetch( url, fetchOptions).then( throwOnNotOk);
    if( parseResponse) return response.status !== 204 ? response.text() : '';
    return response;
  } catch (error) {
    console.error( new Date(), 'helpers::Network::Call - error: ', error);
    if( parseResponse) tryParseOnNetworkError( error);
    else throw error;
  }
}
Call.head = (url, fetchOptions, callOptions) => Call( url, { ...fetchOptions, method: Methods.HEAD }, callOptions);
Call.get = (url, fetchOptions, callOptions) => Call( url, { ...fetchOptions, method: Methods.GET }, callOptions);
Call.post = (url, fetchOptions, callOptions) => Call( url, { ...fetchOptions, method: Methods.POST }, callOptions);
Call.put = (url, fetchOptions, callOptions) => Call( url, { ...fetchOptions, method: Methods.PUT }, callOptions);
Call.delete = (url, fetchOptions, callOptions) => Call( url, { ...fetchOptions, method: Methods.DELETE }, callOptions);
